module.exports = __webpack_public_path__ + "static/media/32-11.1d17d614.mp3";